// src/pages/client/TaskToolbar.jsx
import React from 'react';
import { Search, PlusCircle, CalendarDays, LogOut, Menu, X } from 'lucide-react';
import gecimo_logo from '../../image/gecimo_logo.jpg';

const TaskToolbar = ({
  onShowForm,
  onSearch,
  onDateStartChange,
  onDateEndChange,
  onLogout,
  onMenuToggle,
  isMobile,
  mobileMenuOpen
}) => (
  <div className="sticky top-0 z-30 bg-white border-b border-gray-200 px-4 py-3 shadow-sm">
    <div className="flex items-center justify-between gap-3">
      {/* Logo & Menu Button */}
      <div className="flex items-center space-x-2 min-w-[50px]">
        {isMobile && (
          <button 
            onClick={onMenuToggle}
            className="p-2 rounded-md text-gray-600 hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="h-5 w-5" />
            ) : (
              <Menu className="h-5 w-5" />
            )}
          </button>
        )}
        <img src={gecimo_logo} alt="Logo" className="h-6 w-auto object-contain" />
        <span className="text-base font-semibold text-gray-800 hidden sm:block">Tickets</span>
      </div>

      {/* Search Bar - Always visible but adapts to screen size */}
      <div className="flex-1 max-w-lg mx-2 min-w-[120px]">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-4 w-4 text-gray-400" />
          </div>
          <input
            type="text"
            placeholder="Rechercher..."
            onChange={e => onSearch(e.target.value)}
            className="block w-full pl-10 pr-3 py-2 border border-gray-200 rounded-lg text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#875A7B] focus:border-transparent transition-all duration-200"
          />
        </div>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-2">
        {/* Date Filter - Hidden on small screens */}
        <div className="hidden md:flex items-center space-x-2 bg-gray-50 rounded-lg p-1 border border-gray-200">
          <CalendarDays className="h-4 w-4 text-[#875A7B] ml-1" />
          <div className="flex items-center space-x-1">
            <input
              type="date"
              onChange={e => onDateStartChange(e.target.value)}
              className="text-xs border border-gray-200 rounded px-2 py-1.5 w-28 bg-white focus:ring-2 focus:ring-[#875A7B] focus:outline-none"
              title="Date de début"
            />
            <span className="text-xs text-gray-400">→</span>
            <input
              type="date"
              onChange={e => onDateEndChange(e.target.value)}
              className="text-xs border border-gray-200 rounded px-2 py-1.5 w-28 bg-white focus:ring-2 focus:ring-[#875A7B] focus:outline-none"
              title="Date de fin"
            />
          </div>
        </div>

        {/* Create Button */}
        <button
          onClick={onShowForm}
          className="inline-flex items-center gap-1 px-3 py-2 rounded-lg bg-[#875A7B] text-white text-sm font-medium shadow-sm hover:bg-[#734d66] focus:outline-none focus:ring-2 focus:ring-[#875A7B] transition-all duration-200 whitespace-nowrap"
          title="Nouveau ticket"
        >
          <PlusCircle className="h-4 w-4" />
          <span className="hidden sm:inline">Nouveau</span>
        </button>

        {/* Logout Button */}
        <button
          onClick={onLogout}
          className="p-2 rounded-lg text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300 transition-all duration-200"
          title="Déconnexion"
        >
          <LogOut className="h-4 w-4 text-gray-600" />
        </button>
      </div>
    </div>
  </div>
);

export default TaskToolbar;